// extracted by mini-css-extract-plugin
module.exports = {"title":"_3iCqx84u","logo":"_11y89Vk_","logoList":"_36M-cT0r"};